import { useState } from "react";
import Header from "../Components/common/Header";
import AttendanceTable from "../Components/common/AttendanceTable";
import Layout from "../Components/Layout";

const TimeSheet = () => {
const [attendanceList, setAttendanceList] = useState([]);
const [refreshKey, setRefreshKey] = useState(0); // 🔁 Used to signal refresh

const handleNewEntry = (newEntry) => {
  setAttendanceList((prevList) => [newEntry, ...prevList]);
  setRefreshKey((prev) => prev + 1); // 🔄 Trigger re-fetch in AttendanceTable
};


  return (
    <Layout>
      <div className="backgound-main-content">
        <Header onNewEntry={handleNewEntry} />
        <AttendanceTable
          attendanceList={attendanceList}
          setAttendanceList={setAttendanceList}
            refreshKey={refreshKey}
        />
      </div>
    </Layout>
  );
};

export default TimeSheet;
